<template>
  <div
    v-if="author"
    class="AuthorCard"
  >
    <div
      class="data"
      :style="{background: `linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.8) 60%), url(${imageRoute}) no-repeat center center/cover`}"
    >
      <h2> {{ author.Nombre }} {{ author.Apellidos }} </h2>
      <div class="categories">
        <p
          v-for="disciplina in author.userdatas"
          :key="disciplina.id"
          class="category"
        >
          {{ disciplina.disciplina.txt }}
        </p>
      </div>
      <!--
      <p class="location">
        {{ author.User.territorio.txt }} / {{ author.User.municipio.txt }}
      </p>

    </div>
    <div class="description">
      {{ author.description }}
    </div>
  </div>
  -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    author: {
      type: Object,
      required: true,
    },

  },

  computed: {
    imageRoute() {
      if (this.author?.userdatas[0].image) {
        return `${process.env.VUE_APP_BASE_URL}/uploads/images/${this.author?.userdatas[0].image}`;
      }

      // eslint-disable-next-line global-require
      return `${require('@/assets/images/paints/renoir.jpg')}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.data {
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  height: 180px;
  color: white;
  gap: 10px;
  padding-bottom: 0.5rem;
  position: relative;
  cursor: pointer;
  h2 {
    font-size: 1.3rem;
    font-weight: bold;
    text-transform: uppercase;
  }
  p {
    font-size: 1rem;
  }
  .categories {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
  }
  &:hover::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: adjust-color($color-primary, $alpha: -0.9);
  }
  &:hover::after {
    content: 'VER MÁS';
    position: absolute;
    top: 20%;
    width: 100%;
    height: 50px;
    text-align: center;
    line-height: 50px;
    background-color: adjust-color($color-primary, $alpha: -0.3);
  }
}
.description {
  color: #494949;
  font-size: 0.9rem;
  margin-top: 1rem;
}
</style>
